function IconLinkedin() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
    >
      <title />
      <g id="icomoon-ignore" />
      <path
        d="M467.478 0h-422.957c-23.102 3.377-41.145 21.419-44.487 44.237l-0.034 0.284v422.957c3.377 23.103 21.419 41.145 44.237 44.488l0.284 0.034h422.957c23.103-3.377 41.145-21.419 44.488-44.238l0.034-0.284v-422.957c-3.377-23.102-21.419-41.145-44.238-44.487l-0.284-0.034zM156.494 428.522h-72.793v-233.739h72.793v233.739zM119.986 162.727c-23.236 0-42.073-18.837-42.073-42.073s18.837-42.073 42.073-42.073c23.237 0 42.073 18.837 42.073 42.073v0c0 0.013 0 0.029 0 0.044 0 23.212-18.817 42.029-42.029 42.029-0.016 0-0.031 0-0.047 0h0.002zM428.522 428.522h-72.793v-113.753c0-27.159-0.445-61.885-37.621-61.885-37.844 0-43.632 29.385-43.632 59.882v115.757h-72.57v-233.739h69.676v31.833h1.113c13.486-22.698 37.878-37.672 65.767-37.672 0.983 0 1.962 0.018 2.937 0.055l-0.14-0.004c73.683 0 87.262 48.306 87.262 111.305v128.222z"
        fill="currentColor"
      />
    </svg>
  );
}

export { IconLinkedin };
